module.exports = __webpack_public_path__ + "img/logoksai.9039971f.png";